// 港口管理模块国际化 - 中文
export default {
  routeSelection: {
    ambiguousLabel: '待确认',
    firstPlaceholder: '请选择一级航线',
    secondPlaceholder: '请选择二级航线',
    ambiguous: '存在多条不同的航线路径，请确认后重新选择；未修改航线时保留原有关联。',
    invalid: '存在空类型或类型不匹配的历史关联，已从选择中排除；未修改航线时不会清理原数据。',
    loadFailed: '航线数据加载失败，请重新打开编辑窗口；原有关联不会被清空。',
    saveFailed: '航线关联保存失败，请检查后重试；未完成全部保存。'
  },
  title: '港口管理',

  // 标签页
  tabs: {
    seaport: '海港',
    riverPort: '河港',
    inlandPoint: '内陆点',
    portGroup: '港口组',
    airport: '空港',
    railwayStation: '铁路站点'
  },

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '港口名称、UN Location',
    airportKeywordPlaceholder: '机场名称、IATA代码',
    country: '国家地区',
    countryPlaceholder: '选择国家',
    isBasePort: '是否基本港',
    isBasePortPlaceholder: '选择类型',
    status: '状态',
    statusPlaceholder: '选择状态',
    yes: '是',
    no: '否',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addSeaport: '新增海港',
    addAirport: '新增空港',
    addCurrentPort: '自主新增{type}',
    copySeaportFromPlatform: '复制平台海港',
    copyCurrentPortFromPlatform: '复制平台{type}',
    copyAllCurrentPortFromPlatform: '一键复制平台{type}',
    copyAirportFromPlatform: '复制平台空港',
    edit: '编辑',
    ediSetting: 'EDI代码设置',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enableItem: '启用',
    disableItem: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    portNameCn: '港口名称（中文）',
    portNameEn: '港口名称（英文）',
    airportNameCn: '机场名称（中文）',
    airportNameEn: '机场名称（英文）',
    unLocation: 'UN Location',
    iataCode: 'IATA代码',
    country: '国家地区',
    countryIsoCode: '国家二字码',
    province: '州/省份',
    city: '城市',
    cityCn: '城市（中文）',
    cityEn: '城市（英文）',
    portType: '港口类型',
    amsPortCode: 'AMS港口代码',
    isBasePort: '是否基本港',
    relatedRoutes: '相关航线',
    level1Route: '一级航线',
    level2Route: '二级航线',
    relatedTerminals: '关联码头',
    ediCodes: 'EDI代码',
    longitude: '经度',
    latitude: '纬度',
    status: '状态',
    operation: '操作'
  },

  // 弹窗
  modal: {
    // 编辑弹窗
    editSeaport: '编辑海港',
    addSeaport: '新增海港',
    editCurrentPort: '编辑{type}',
    addCurrentPort: '新增{type}',
    editAirport: '编辑空港',
    addAirport: '新增空港',
    basicInfo: '基本信息',
    editableInfo: '可编辑信息',

    // 选择弹窗
    selectSeaportTitle: '复制平台海港',
    selectCurrentPortTitle: '复制平台{type}',
    selectAirportTitle: '复制平台空港',
    confirmAddSeaport: '复制新增 {count} 个海港',
    confirmAddCurrentPort: '复制新增 {count} 个{type}',
    confirmAddAirport: '复制新增 {count} 个空港',
    cancel: '取消',
    selected: '已选择 {count} 个，共 {total} 个可选',
    selectedAllSummary: '已选择 {count} 个，共 {total} 个可选',
    selectAllFiltered: '选择当前筛选条件下可复制的全部 {total} 条',
    allFilteredSelectedHint: '已按当前筛选条件全选，共 {total} 条；已排除 {excluded} 条',
    clearSelected: '清空已选',
    selectedPreview: '已选明细',
    excludedPreview: '已排除明细',
    selectedDetailCount: '{count} 条',
    selectedEmpty: '暂未选择，勾选右侧平台数据后会出现在这里',
    platformDataTitle: '平台数据',
    availableTotal: '共 {total} 条可选',
    platformTotal: '平台共 {total} 条，本次可复制 {available} 条',
    querySelectedNotice: '已按当前筛选条件全选可复制数据 {total} 条，左侧不逐条展示全部数据；可在右侧取消勾选作为排除项，当前已排除 {excluded} 条',
    copyStatus: '复制状态',
    copyStatusAvailable: '可复制',
    copyStatusExists: '已存在',
    copyStatusAll: '全部',
    copyStatusPlaceholder: '选择复制状态',
    syncLimitNotice: '当前选择 {count} 条，超过同步复制上限 {limit} 条，请缩小筛选条件后重试',

    // EDI设置弹窗
    ediTitle: 'EDI代码设置',
    carrier: '承运人',
    ediCode: 'EDI代码',
    addEdiCode: '添加EDI代码',
    deleteEdiCode: '删除',
    duplicateWarning: '重复',
    duplicateAlert: '检测到重复的承运人+EDI代码组合，请检查第 {rows} 行'
  },

  // 确认对话框
  confirm: {
    enableSeaport: '确定要启用此港口吗？',
    disableSeaport: '确定要禁用此港口吗？',
    enableCurrentPort: '确定要启用此{type}吗？',
    disableCurrentPort: '确定要禁用此{type}吗？',
    copyAllCurrentPortTitle: '一键复制平台{type}',
    copyAllCurrentPortContent: '确定将平台可用{type}复制到当前租户吗？已存在的数据会自动跳过，任务将在后台执行。',
    copyAllCurrentPortOk: '创建任务',
    copyWillCreateTaskTitle: '创建后台复制任务',
    copyWillCreateTaskContent: '当前选择 {count} 条{type}数据，提交后将创建后台任务，可在任务中心查看处理详情。',
    copyWillCreateTaskOk: '创建任务',
    copyTaskRedirectTitle: '任务已提交',
    copyTaskRedirectContent: '复制任务已进入任务管理，可前往查看进度和结果。',
    copyTaskRedirectOk: '前往任务管理',
    suspectedDuplicateTitle: '疑似重复港口',
    suspectedDuplicateNameCnCountry: '当前中文名称和国家二字码与已有港口一致，可能是重复港口。',
    suspectedDuplicateNameEnCountry: '当前英文名称和国家二字码与已有港口一致，可能是重复港口。',
    suspectedAirportDuplicateTitle: '疑似重复空港',
    suspectedAirportDuplicateNameCnCountry: '当前中文名称和国家二字码与已有空港一致，可能是重复空港。',
    suspectedAirportDuplicateNameEnCountry: '当前英文名称和国家二字码与已有空港一致，可能是重复空港。',
    suspectedDuplicateOk: '继续保存',
    suspectedDuplicateCancel: '返回修改',
    enableAirport: '确定要启用此机场吗？',
    disableAirport: '确定要禁用此机场吗？'
  },

  // 表单相关
  form: {
    portNameEn: '港口全称（英文）',
    portNameCn: '港口全称（中文）',
    airportNameEn: '机场全称（英文）',
    airportNameCn: '机场全称（中文）',
    unLocation: 'UN Location',
    iataCode: 'IATA代码',
    country: '国家（地区）',
    countryIsoCode: '国家二字码',
    province: '州/省份',
    city: '城市',
    cityCn: '城市（中文）',
    cityEn: '城市（英文）',
    portType: '港口类型',
    amsPortCode: 'AMS港口代码',
    longitude: '经度',
    latitude: '纬度',
    isBasePort: '是否基港',
    relatedRoutes: '关联航线',
    relatedTerminals: '关联码头',

    // 表单验证
    portNameEnRequired: '请输入港口英文名称',
    portNameCnRequired: '请输入港口中文名称',
    airportNameEnRequired: '请输入机场英文名称',
    airportNameCnRequired: '请输入机场中文名称',
    unLocationRequired: '请输入UN Location',
    iataCodeRequired: '请输入IATA代码',
    countryRequired: '请选择国家',
    amsPortCodeRequired: '请输入AMS港口代码',
    longitudeRequired: '请输入经度',
    latitudeRequired: '请输入纬度',
    carrierRequired: '请选择承运人',
    ediCodeRequired: '请输入EDI代码',

    // 表单占位符
    portNameEnPlaceholder: '请输入港口英文名称',
    portNameCnPlaceholder: '请输入港口中文名称',
    airportNameEnPlaceholder: '请输入机场英文名称',
    airportNameCnPlaceholder: '请输入机场中文名称',
    unLocationPlaceholder: '请输入UN Location代码',
    iataCodePlaceholder: '请输入IATA代码，如：PVG',
    countryPlaceholder: '请选择国家',
    countryIsoCodePlaceholder: '请输入国家二字码',
    provincePlaceholder: '请输入州/省份',
    cityPlaceholder: '请输入城市',
    portTypePlaceholder: '请输入港口类型',
    amsPortCodePlaceholder: '请输入AMS港口代码',
    longitudePlaceholder: '请输入经度，如：121.4737',
    latitudePlaceholder: '请输入纬度，如：31.2304',
    relatedRoutesPlaceholder: '请选择关联航线',
    relatedTerminalsPlaceholder: '请选择关联码头',
    carrierPlaceholder: '选择承运人',
    ediCodePlaceholder: '输入EDI代码'
  },

  // 消息提示
  messages: {
    // 选择提示
    selectSeaportToEnable: '请选择要启用的海港',
    selectSeaportToDisable: '请选择要禁用的海港',
    selectCurrentPortToEnable: '请选择要启用的{type}',
    selectCurrentPortToDisable: '请选择要禁用的{type}',
    selectAirportToEnable: '请选择要启用的空港',
    selectAirportToDisable: '请选择要禁用的空港',
    selectPortsToAdd: '请选择要复制的海港',
    selectCurrentPortsToAdd: '请选择要复制的{type}',
    selectAirportsToAdd: '请选择要复制的空港',

    // 操作成功
    seaportEnabled: '海港已启用',
    seaportDisabled: '海港已禁用',
    currentPortEnabled: '{type}已启用',
    currentPortDisabled: '{type}已禁用',
    airportEnabled: '空港已启用',
    airportDisabled: '空港已禁用',
    seaportBatchEnabled: '已启用 {count} 个海港',
    seaportBatchDisabled: '已禁用 {count} 个海港',
    currentPortBatchEnabled: '已启用 {count} 个{type}',
    currentPortBatchDisabled: '已禁用 {count} 个{type}',
    airportBatchEnabled: '已启用 {count} 个空港',
    airportBatchDisabled: '已禁用 {count} 个空港',
    seaportAssociateSuccess: '已复制新增 {count} 个海港',
    currentPortAssociateSuccess: '已复制新增 {count} 个{type}',
    airportAssociateSuccess: '已复制新增 {count} 个空港',
    copyTaskSubmitted: '已创建{type}后台复制任务（任务中心ID：{taskId}），本次预计复制 {count} 条，可前往任务中心查看处理详情',
    copyTaskAlreadyRunning: '已有{type}复制任务正在执行（任务中心ID：{taskId}），请前往任务中心查看处理详情',
    editSuccess: '编辑成功',
    addSuccess: '新增成功',
    unLocationDuplicate: 'UN Location已存在，不允许保存',
    iataCodeDuplicate: 'IATA代码已存在，不允许保存',
    duplicateCheckError: '港口重复校验失败，请稍后重试',
    ediSettingSuccess: 'EDI代码设置成功',
    ediClearedSuccess: 'EDI代码已清空',
    associationSaveSuccess: '关联信息保存成功',
    partialAssociationSave: '部分关联信息保存成功',
    noAssociationToSave: '没有需要保存的关联信息',

    // 操作失败
    statusToggleError: '状态切换失败，请稍后重试',
    seaportBatchEnableError: '批量启用失败，请稍后重试',
    seaportBatchDisableError: '批量禁用失败，请稍后重试',
    currentPortBatchEnableError: '批量启用{type}失败，请稍后重试',
    currentPortBatchDisableError: '批量禁用{type}失败，请稍后重试',
    airportBatchEnableError: '批量启用失败，请稍后重试',
    airportBatchDisableError: '批量禁用失败，请稍后重试',
    seaportAssociateError: '复制新增海港失败，请稍后重试',
    currentPortAssociateError: '复制新增{type}失败，请稍后重试',
    airportAssociateError: '复制新增空港失败，请稍后重试',
    copyTaskSubmitError: '创建{type}后台复制任务失败，请稍后重试',
    editError: '编辑失败',
    addError: '新增失败',
    ediSettingError: 'EDI代码设置失败',
    associationSaveError: '关联信息保存失败，请稍后重试',

    // 数据加载失败
    seaportLoadError: '海港数据加载失败，请稍后重试',
    currentPortLoadError: '{type}数据加载失败，请稍后重试',
    airportLoadError: '空港数据加载失败，请稍后重试',
    platformSeaportLoadError: '加载平台海港失败，请稍后重试',
    platformCurrentPortLoadError: '加载平台{type}失败，请稍后重试',
    platformAirportLoadError: '加载平台空港失败，请稍后重试',
    countryLoadError: '国家数据加载失败，使用默认数据',
    carrierLoadError: '承运人数据加载失败，使用默认数据',
    routeLoadError: '航线数据加载失败，使用默认数据',

    // 重复数据提示
    duplicateEdiCombination: '第 {rows} 行存在重复的承运人+EDI代码组合，请检查后重试',
    duplicateEdiCheck: '第 {rows} 行存在重复的承运人+EDI代码组合，请先处理重复数据'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用',
    yes: '是',
    no: '否',
    notSet: '未设置',
    codesCount: '{count} 个代码'
  },

  // 分页
  pagination: {
    total: '共 {count} 条',
    itemsPerPage: '{size} 条/页',
    goTo: '前往'
  },

  railwayStation: {
    search: {
      keywordPlaceholder: '国铁编码 / 中文名 / 英文名 / 别名',
      railwayCarrierPlaceholder: '所属铁路公司',
      countryPlaceholder: '国家',
      stationTypePlaceholder: '车站类型',
      operationStatusPlaceholder: '运营状态',
      enabledPlaceholder: '启用状态',
      search: '搜索',
      reset: '重置'
    },
    actions: {
      add: '新增铁路站点',
      view: '查看',
      enable: '启用',
      disable: '禁用',
      delete: '删除',
      batchEnable: '批量启用',
      batchDisable: '批量禁用',
      batchDelete: '批量删除'
    },
    table: {
      stationCode: '国铁编码',
      name: '站点名称',
      railwayCarrier: '所属铁路公司',
      location: '国家/省州',
      railwayLineName: '物理线路',
      belongingChannel: '所属通道',
      trackGauge: '轨距',
      stationType: '车站类型',
      operationStatus: '运营状态',
      operationDirection: '运营方向',
      borderChannelType: '跨境通道分类',
      gaugeChange: '换轨',
      borderPort: '是否口岸',
      containerTypes: '可操作箱型',
      enabled: '启用状态',
      operations: '操作'
    },
    detail: {
      title: '铁路站点详情',
      stationCode: '国铁编码',
      nameCn: '标准中文名',
      nameEn: '标准英文名',
      aliasName: '别名/简称',
      railwayCarrier: '所属铁路公司',
      location: '国家/省州',
      railwayLineName: '所属物理线路',
      belongingChannel: '所属通道',
      trackGauge: '轨距',
      stationType: '车站类型',
      operationStatus: '运营状态',
      operationDirection: '运营方向',
      borderChannelType: '跨境通道分类',
      gaugeChange: '换轨',
      borderPort: '是否口岸',
      foreignStationName: '对应外方站点',
      foreignUicCode: '外方 UIC 编码',
      customsSupervisionCode: '海关监管代码',
      coordinate: '经纬度',
      maxLoadLimit: '最大载重限制',
      containerTypes: '可操作箱型'
    },
    options: {
      enabled: '启用',
      disabled: '禁用',
      yes: '是',
      no: '否',
      stationType: {
        marshalling: '编组站',
        freight: '货运站',
        passenger: '客运站',
        border: '口岸站',
        privateLine: '专用线',
        boundary: '分界站'
      },
      operationStatus: {
        enabled: '启用',
        suspended: '临时关闭',
        decommissioned: '永久停用',
        migrated: '更名迁移'
      },
      operationDirection: {
        both: '双向',
        outboundOnly: '仅去程',
        inboundOnly: '仅回程'
      },
      borderChannelType: {
        east: '东通道',
        middle: '中通道',
        west: '西通道',
        north: '北线',
        south: '南线'
      }
    },
    modal: {
      title: '新增铁路站点',
      confirmText: '确认新增 ({count})',
      selected: '已选择 {count} 条，可新增 {total} 条',
      searchPlaceholder: '国铁编码 / 中文名 / 英文名 / 别名'
    },
    confirm: {
      batchDelete: '确认删除选中的铁路站点？',
      enable: '确认启用该铁路站点？',
      disable: '确认禁用该铁路站点？',
      delete: '确认删除该铁路站点？'
    },
    messages: {
      loadError: '加载铁路站点失败',
      platformLoadError: '加载平台铁路站点失败',
      selectToAssociate: '请选择要新增的铁路站点',
      associateSuccess: '已新增 {count} 个铁路站点',
      associateError: '新增铁路站点失败',
      enableSuccess: '启用成功',
      disableSuccess: '禁用成功',
      updateStatusError: '更新状态失败',
      deleteSuccess: '删除成功',
      deleteError: '删除铁路站点失败'
    },
    stats: {
      total: '共 {total} 条'
    },
    format: {
      gaugeChange: '换轨 {count} 次',
      maxLoadLimit: '{value} 吨'
    }
  },

  // 港口组管理
  portGroup: {
    title: '港口组管理',
    search: {
      keyword: '关键词搜索',
      keywordPlaceholder: '搜索港口组名称或代码',
      status: '启用状态',
      statusPlaceholder: '请选择状态',
      searchButton: '搜索',
      resetButton: '重置'
    },
    table: {
      code: '港口组代码',
      nameCn: '中文名称',
      nameEn: '英文名称',
      portCount: '关联港口数',
      status: '启用状态',
      createdTime: '创建时间',
      operations: '操作',
      recordsCount: '共 {count} 条记录'
    },
    actions: {
      create: '新建',
      createSelf: '自主新增港口组',
      copyFromPlatform: '复制平台港口组',
      edit: '编辑',
      delete: '删除'
    },
    form: {
      title: {
        create: '新建港口组',
        edit: '编辑港口组'
      },
      code: '港口组代码',
      codePlaceholder: '请输入港口组代码（如 PG001）',
      codeRequired: '请输入港口组代码',
      nameCn: '中文名称',
      nameCnPlaceholder: '请输入港口组中文名称',
      nameCnRequired: '请输入港口组中文名称',
      nameEn: '英文名称',
      nameEnPlaceholder: '请输入港口组英文名称',
      portCodes: '关联港口',
      portCodesPlaceholder: '请选择关联港口',
      portCodesRequired: '请至少选择一个港口',
      routes: '关联航线',
      routesPlaceholder: '请选择关联航线（可选）',
      enabled: '启用状态',
      cancel: '取消',
      save: '保存'
    },
    tooltip: {
      portList: '关联港口明细'
    },
    confirm: {
      deleteTitle: '确认删除',
      deleteContent: '确定要删除港口组「{name}」({code}) 吗？',
      deleteWarning: '该港口组关联了 {count} 条运价记录，删除后运价中的港口组字段将被清空。',
      deleteOk: '确认删除',
      deleteCancel: '取消'
    },
    modal: {
      copyPlatformTitle: '复制平台港口组',
      confirmCopy: '确认复制 ({count})',
      copyStatus: '复制状态',
      copyStatusPlaceholder: '筛选复制状态',
      copyStatusAvailable: '可复制',
      copyStatusExists: '已复制',
      copyStatusAll: '全部',
      selectedPreview: '已选预览',
      selectedCount: '已选 {count} 项',
      clearSelected: '清空已选',
      selectedEmpty: '请从右侧列表选择港口组',
      platformDataTitle: '平台港口组列表',
      platformTotal: '共 {total} 条',
      selectAllFiltered: '全选当前页 ({total})',
      copySuccess: '复制成功',
      copyError: '复制失败'
    },
    messages: {
      loadError: '加载港口组列表失败',
      loadDetailError: '加载港口组详情失败',
      loadPlatformError: '加载平台港口组失败',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      deleteSuccess: '删除成功',
      deleteError: '删除失败',
      selectWarning: '请选择要复制的港口组'
    }
  }
}
